import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PAYMENT_METHODS, PaymentSummaryContext } from "../constants";

const PaymentSummary: FC<PaymentSummaryContext & { className?: string }> = ({
  selectedPayment,
  currency,
}) => {
  const { t } = useTranslation();
  const config = PAYMENT_METHODS[selectedPayment.paymentMethod];

  return (
    <div className="flex flex-col gap-1">
      <div className="text-font-subtle text-xs font-medium uppercase tracking-wide">
        {t("Flights.details.payment.youAreAboutToPay")}
      </div>
      <div className="text-font-default text-xl font-bold md:text-2xl">
        {config.renderSummaryValue({ selectedPayment, currency })}
      </div>
      <div className="text-font-subtle text-xs font-medium">
        {config.renderSummaryNote({ selectedPayment, currency })}
      </div>
    </div>
  );
};

export default PaymentSummary;
